import { render, staticRenderFns } from "./customerTime.vue?vue&type=template&id=a3143bf6&scoped=true"
import script from "./customerTime.vue?vue&type=script&lang=js"
export * from "./customerTime.vue?vue&type=script&lang=js"
import style0 from "./customerTime.vue?vue&type=style&index=0&id=a3143bf6&lang=css"
import style1 from "./customerTime.vue?vue&type=style&index=1&id=a3143bf6&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3143bf6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/重构-快递前端-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a3143bf6')) {
      api.createRecord('a3143bf6', component.options)
    } else {
      api.reload('a3143bf6', component.options)
    }
    module.hot.accept("./customerTime.vue?vue&type=template&id=a3143bf6&scoped=true", function () {
      api.rerender('a3143bf6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ReportManagement/SHEINDailyDeliveryData/components/customerTime.vue"
export default component.exports